module.exports = __webpack_public_path__ + "static/img/M6-S-462-1.b4534fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/module6/M6-S-462-1.png
// module id = 173
// module chunks = 0